const geofence = {
  name: "Geofence",
  geofenceName: "ชื่อขอบเขตภูมิศาสตร์",
  in: "ขับรถเข้ามา",
  out: "ขับออกไป",
  shape: {
    name: "Shape of fence",
    circle: "วงกลม",
    rectangle: "สี่เหลี่ยมผืนผ้า",
    polygon: "รูปหลายเหลี่ยม",
    warning: {
      circle: "โปรดกำหนดจุดศูนย์กลางและรัศมี",
      rectangle: "กรุณาวาดรูปสี่เหลี่ยมผืนผ้า",
      polygon: "กรุณาวาดอย่างน้อย 3 จุด"
    }
  },
  radius: "รัศมี",
  centerPosition: "ศูนย์กลาง",
  mapPoint: "เลือกจุดจากแผนที่",
  style: {
    queryLabelWidth: "120px",
    formLabelWidth: "90px",
    formLabelWidth2: "160px"
  }
} 
export default geofence